import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import {
  Card,
  Divider,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

const QUESTION_COUNT_OPTIONS = [10, 15, 20];
const QUESTION_TYPE_OPTIONS = ["easy", "medium", "hard"];
const RATIO_OPTIONS = {
  10: [
    "3:3:2:2",
    "3:2:3:2",
    "2:3:3:2",
    "2:3:2:3",
    "2:2:3:3",
    "4:2:2:2",
    "2:4:2:2",
    "2:2:4:2",
    "2:2:2:4",
    "4:3:2:1",
    "4:2:3:1",
    "3:4:2:1",
    "3:2:4:1",
  ],
  15: [
    "4:4:4:3",
    "4:4:3:4",
    "4:3:4:4",
    "3:4:4:4",
    "5:4:3:3",
    "5:3:4:3",
    "5:3:3:4",
    "4:5:3:3",
    "4:3:5:3",
    "4:3:3:5",
    "3:5:4:3",
    "3:5:3:4",
    "3:4:5:3",
    "3:4:3:5",
    "3:3:5:4",
    "3:3:4:5",
    "6:3:3:3",
    "3:6:3:3",
    "3:3:6:3",
    "3:3:3:6",
  ],
  20: [
    "5:5:5:5",
    "6:4:5:5",
    "5:6:4:5",
    "5:5:6:4",
    "4:5:5:6",
    "7:3:7:3",
    "7:3:3:7",
    "3:7:7:3",
    "3:7:3:7",
    "7:7:3:3",
    "3:3:7:7",
    "6:6:4:4",
    "6:4:6:4",
    "6:4:4:6",
    "4:6:6:4",
    "4:6:4:6",
    "4:4:6:6",
    "4:5:6:5",
    "4:6:5:5",
    "5:4:6:5",
    "5:4:5:6",
    "5:6:5:4",
    "6:5:4:5",
    "6:5:5:4",
    "5:6:4:5",
    "5:5:4:6",
  ],
};

const answerLabelMap = {
  option1: "Option 1",
  option2: "Option 2",
  option3: "Option 3",
  option4: "Option 4",
};

export default class AIQuestions extends Component {
  state = {
    notification: false,
    message: "",
    notificationColor: "success",
    redirect: false,
    allSubjects: [],
    alltopics: [],
    allLevels: [],
    subject_id: "",
    topic_id: "",
    level_id: "",
    search: "",
    topic_prompt: "",
    number_of_questions: 20,
    question_type: "easy",
    option_frequency: "5:5:5:5",
    generating: false,
    saving: false,
    generatedQuestions: [],
    generatedMeta: null,
  };

  componentDidMount() {
    this.getAllSubjects();
  }

  showNotification = (message, color = "success") => {
    this.setState({
      notification: true,
      message,
      notificationColor: color,
    });

    setTimeout(() => {
      this.setState({ notification: false, message: "", notificationColor: "success" });
    }, 4000);
  };

  getAllSubjects = async () => {
    if (init() === "success") {
      const response = await axios.get(
        `${Constants.getUrls.getAllSubjects}?search=${this.state.search}&limit=1000&page=1`
      );
      this.setState({
        allSubjects: response?.data?.data?.docs || [],
      });
    }
  };

  handleTopic = async () => {
    if (init() === "success") {
      const response = await axios.get(
        `${Constants.getUrls.getAllTopics}?subject_id=${this.state.subject_id}`
      );
      this.setState({
        alltopics: response?.data?.data?.docs || [],
        topic_id: "",
        level_id: "",
        allLevels: [],
        topic_prompt: "",
        generatedQuestions: [],
        generatedMeta: null,
      });
    }
  };

  handleLevel = async () => {
    if (init() === "success") {
      const response = await axios.get(
        `${Constants.getUrls.getAllLevels}?subject_id=${this.state.subject_id}&topic_id=${this.state.topic_id}`
      );
      this.setState({
        allLevels: response?.data?.data?.docs || [],
        level_id: "",
        generatedQuestions: [],
        generatedMeta: null,
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleQuestionCountChange = (value) => {
    const nextRatio = RATIO_OPTIONS[value]?.[0] || "";
    this.setState({
      number_of_questions: value,
      option_frequency: nextRatio,
      generatedQuestions: [],
      generatedMeta: null,
    });
  };

  handleTopicSelect = (topicId) => {
    const selectedTopic = this.state.alltopics.find((item) => item._id === topicId);
    this.setState(
      {
        topic_id: topicId,
        topic_prompt: selectedTopic?.topic_name || "",
      },
      () => this.handleLevel()
    );
  };

  updateGeneratedQuestionField = (index, field, value) => {
    this.setState((prevState) => {
      const generatedQuestions = [...prevState.generatedQuestions];
      generatedQuestions[index] = {
        ...generatedQuestions[index],
        [field]: value,
      };
      return { generatedQuestions };
    });
  };

  handleGenerate = async (e) => {
    e.preventDefault();

    const {
      subject_id,
      topic_id,
      level_id,
      topic_prompt,
      number_of_questions,
      question_type,
      option_frequency,
    } = this.state;

    if (!subject_id || !topic_id || !level_id || !topic_prompt.trim()) {
      this.showNotification("Please fill subject, topic, level and topic prompt first.", "error");
      return;
    }

    this.setState({ generating: true });

    try {
      const payload = {
        subject_id,
        topic_id,
        level_id,
        topic_prompt: topic_prompt.trim(),
        number_of_questions,
        question_type,
        option_frequency,
      };

      const response = await axios.post(Constants.postUrls.generateAIQuestions, payload);
      this.setState({
        generatedQuestions: response?.data?.data?.questions || [],
        generatedMeta: response?.data?.data || null,
      });
      this.showNotification(response?.data?.message || "Questions generated successfully.");
    } catch (error) {
      this.showNotification(
        error?.response?.data?.message || "Failed to generate questions.",
        "error"
      );
    } finally {
      this.setState({ generating: false });
    }
  };

  handleSaveQuestions = async () => {
    if (!this.state.generatedQuestions.length) {
      this.showNotification("Generate questions before saving.", "error");
      return;
    }

    this.setState({ saving: true });

    try {
      const payload = {
        subject_id: this.state.subject_id,
        level_id: this.state.level_id,
        topic_id: this.state.topic_id,
        questionsArray: JSON.stringify(this.state.generatedQuestions),
      };

      const response = await axios.post(Constants.postUrls.creatBulkImport, payload);
      this.showNotification(response?.data?.message || "Questions added successfully.");
      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (error) {
      this.showNotification(
        error?.response?.data?.message || "Failed to save generated questions.",
        "error"
      );
    } finally {
      this.setState({ saving: false });
    }
  };

  renderQuestionEditor = (question, index) => (
    <Card
      key={`${question.question}-${index}`}
      sx={{
        p: 2.5,
        mb: 2.5,
        borderRadius: 3,
        border: question.duplicate_flag ? "1px solid #ef5350" : "1px solid rgba(0,0,0,0.08)",
        backgroundColor: question.duplicate_flag ? "rgba(239,83,80,0.06)" : "#fff",
      }}
    >
      <MDTypography variant="h6" fontWeight="medium" mb={2}>
        Question {index + 1}
      </MDTypography>

      {question.duplicate_flag ? (
        <MDBox
          mb={2}
          px={1.5}
          py={1.25}
          borderRadius="lg"
          sx={{ backgroundColor: "rgba(239,83,80,0.12)" }}
        >
          <Typography variant="body2" color="error" fontWeight="medium">
            Duplicate detected (
            {question.duplicate_type === "database" ? "already in topic" : "inside generated set"})
          </Typography>
          {question.duplicate_match ? (
            <Typography variant="caption" color="text.secondary">
              Matched question: {question.duplicate_match}
            </Typography>
          ) : null}
        </MDBox>
      ) : null}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Question"
            fullWidth
            multiline
            minRows={2}
            value={question.question}
            onChange={(e) => this.updateGeneratedQuestionField(index, "question", e.target.value)}
          />
        </Grid>

        {["option1", "option2", "option3", "option4"].map((optionKey) => (
          <Grid item xs={12} md={6} key={optionKey}>
            <TextField
              label={answerLabelMap[optionKey]}
              fullWidth
              multiline
              minRows={2}
              value={question[optionKey]}
              onChange={(e) => this.updateGeneratedQuestionField(index, optionKey, e.target.value)}
            />
          </Grid>
        ))}

        <Grid item xs={12} md={6}>
          <InputLabel sx={{ mb: 0.75 }}>Question Type</InputLabel>
          <Select
            fullWidth
            value={question.question_type}
            onChange={(e) =>
              this.updateGeneratedQuestionField(index, "question_type", e.target.value)
            }
            style={{ height: "45px", color: "#111" }}
          >
            {QUESTION_TYPE_OPTIONS.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={12} md={6}>
          <InputLabel sx={{ mb: 0.75 }}>Correct Answer</InputLabel>
          <Select
            fullWidth
            value={question.answer}
            onChange={(e) => this.updateGeneratedQuestionField(index, "answer", e.target.value)}
            style={{ height: "45px", color: "#111" }}
          >
            {Object.entries(answerLabelMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Explanation"
            fullWidth
            multiline
            minRows={3}
            value={question.description}
            onChange={(e) =>
              this.updateGeneratedQuestionField(index, "description", e.target.value)
            }
          />
        </Grid>
      </Grid>
    </Card>
  );

  render() {
    if (this.state.redirect) {
      return <Navigate to="/questions" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                AI Question Generator
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleGenerate}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Select Subject</InputLabel>
                    <Select
                      value={this.state.subject_id}
                      onChange={(e) =>
                        this.setState({ subject_id: e.target.value }, () => this.handleTopic())
                      }
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Subject</MenuItem>
                      {this.state.allSubjects.map((item) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.subject_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputLabel>Select Topic</InputLabel>
                    <Select
                      value={this.state.topic_id}
                      onChange={(e) => this.handleTopicSelect(e.target.value)}
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Topic</MenuItem>
                      {this.state.alltopics.map((item) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.topic_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputLabel>Select Level</InputLabel>
                    <Select
                      value={this.state.level_id}
                      onChange={(e) =>
                        this.setState({
                          level_id: e.target.value,
                          generatedQuestions: [],
                          generatedMeta: null,
                        })
                      }
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Level</MenuItem>
                      {this.state.allLevels.map((item) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.level_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputLabel>Number of Questions</InputLabel>
                    <Select
                      value={this.state.number_of_questions}
                      onChange={(e) => this.handleQuestionCountChange(e.target.value)}
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      {QUESTION_COUNT_OPTIONS.map((item) => (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputLabel>Question Type</InputLabel>
                    <Select
                      value={this.state.question_type}
                      onChange={(e) => this.setState({ question_type: e.target.value })}
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      {QUESTION_TYPE_OPTIONS.map((item) => (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputLabel>Option Frequency Ratio</InputLabel>
                    <Select
                      value={this.state.option_frequency}
                      onChange={(e) => this.setState({ option_frequency: e.target.value })}
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      {(RATIO_OPTIONS[this.state.number_of_questions] || []).map((item) => (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12}>
                    <InputLabel>Topic Prompt</InputLabel>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      name="topic_prompt"
                      value={this.state.topic_prompt}
                      onChange={this.handleInput}
                      required
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} mt={1}>
                  <Grid item>
                    <MDButton
                      variant="contained"
                      size="small"
                      color="info"
                      type="submit"
                      disabled={this.state.generating}
                    >
                      {this.state.generating ? "Generating..." : "Generate Questions"}
                    </MDButton>
                  </Grid>
                </Grid>
              </form>

              {this.state.generatedQuestions.length > 0 ? (
                <>
                  <Divider sx={{ my: 3 }} />

                  <MDBox mb={2}>
                    <MDTypography variant="h6">Generated Question Preview</MDTypography>
                    <Typography variant="body2" color="text.secondary">
                      Review the generated set below. You can edit question text, options, answer,
                      and explanation before saving.
                    </Typography>
                  </MDBox>

                  {this.state.generatedMeta ? (
                    <MDBox mb={2}>
                      <Typography variant="body2" color="text.secondary">
                        Prompt: {this.state.generatedMeta.number_of_questions} questions,{" "}
                        {this.state.generatedMeta.question_type}, ratio{" "}
                        {this.state.generatedMeta.option_frequency}
                      </Typography>
                      <Typography
                        variant="body2"
                        color={
                          this.state.generatedMeta.duplicate_count > 0 ? "error" : "text.secondary"
                        }
                        fontWeight={
                          this.state.generatedMeta.duplicate_count > 0 ? "medium" : "regular"
                        }
                      >
                        Duplicate flags: {this.state.generatedMeta.duplicate_count || 0}
                      </Typography>
                    </MDBox>
                  ) : null}

                  {this.state.generatedQuestions.map(this.renderQuestionEditor)}

                  <MDBox mt={2}>
                    <MDButton
                      variant="contained"
                      size="small"
                      color="success"
                      onClick={this.handleSaveQuestions}
                      disabled={this.state.saving}
                    >
                      {this.state.saving ? "Adding Questions..." : "Add Questions"}
                    </MDButton>
                  </MDBox>
                </>
              ) : null}
            </MDBox>

            <MDSnackbar
              color={this.state.notificationColor}
              icon="notifications"
              title="AgriQuiz Questions"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
